/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';

import classNames from 'classnames';

export default function List({ value, createListItem, row, createOnClick }) {
  if (!value || !createListItem) {
    return null;
  }

  return (
    <ul>
      {value.map((item, index) => {
        return (
          <li
            key={index}
            onClick={createOnClick?.(item, row)}
            className={classNames({
              'cursor-pointer text-indigo-500 underline': !!createOnClick,
            })}
          >
            {createListItem?.(item, row)}
          </li>
        );
      })}
    </ul>
  );
}
